// extracted by mini-css-extract-plugin
module.exports = {"button":"GithubLogin_button__38ue0"};